import { Block } from './types'

export interface BlockRun {
  highlighted: boolean
  entries: { block: Block; index: number }[]
}

/**
 * Split the page into runs of consecutive blocks that share the same
 * highlighted state, so each highlighted run renders as one continuous band
 * rather than each block painting its own (which leaves seams where block
 * margins meet). `index` is the block's position on the whole page.
 */
export const groupHighlightRuns = (blocks: Block[]): BlockRun[] =>
  blocks.reduce<BlockRun[]>((runs, block, index) => {
    const highlighted = !!block.highlighted
    const last = runs[runs.length - 1]
    if (last && last.highlighted === highlighted) {
      last.entries.push({ block, index })
    } else {
      runs.push({ highlighted, entries: [{ block, index }] })
    }
    return runs
  }, [])
